const servicesAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP */

      //H1 BANNER
      let split = SplitText.create(".header h1", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
      });

      //SERVICE
      gsap.utils.toArray(".service h3").forEach((title) => {
        gsap.from(title, {
          /* y: "-100px", */
          opacity: 0,
          duration: 0.8,
          ease: "power3",
          stagger: 0.25,
          scrollTrigger: {
            trigger: title,
            start: "top+=100 80%",
            end: "bottom top",
            scrub: false,
            markers: false,
            toggleActions: "play none none reverse",
          },
        });
      });

      gsap.utils.toArray(".img-2-container").forEach((img2) => {
        gsap.from(img2, {
          scale: 0.5,
          opacity: 0,
          duration: 0.8,
          ease: "power3",
          stagger: 0.25,
          scrollTrigger: {
            trigger: img2,
            start: "top+=100 80%",
            end: "bottom top",
            scrub: false,
            markers: false,
            toggleActions: "play none none reverse",
          },
        });
      });

      

      
    });
  },
};

export default servicesAnim;
